import { render } from "./OnboardClientModal.vue?vue&type=template&id=23d160b1&scoped=true"
import script from "./OnboardClientModal.vue?vue&type=script&lang=js"
export * from "./OnboardClientModal.vue?vue&type=script&lang=js"

import "./OnboardClientModal.vue?vue&type=style&index=0&id=23d160b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d160b1"]])

export default __exports__